module.exports = __webpack_public_path__ + "img/组 13 拷贝@2x.d8443d73.png";